var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Logo from '../../../Logo';
const LogoGoogle = (_a) => {
    var commonProps = __rest(_a, []);
    const source = {
        type: 'svg',
        content: (React.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M28 16.2727C28 15.4218 27.9221 14.6036 27.7773 13.8182H16.2449V18.46H22.8349C22.551 19.96 21.6883 21.2309 20.3914 22.0818V25.0927H24.3488C26.6642 23.0036 28 19.9273 28 16.2727Z", fill: "#4285F4" }),
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.2449 28.0001C19.551 28.0001 22.3228 26.9256 24.3488 25.0928L20.3915 22.0819C19.295 22.8019 17.8924 23.2274 16.2449 23.2274C13.0557 23.2274 10.3562 21.1165 9.39334 18.2801H5.30243V21.3892C7.31727 25.311 11.4583 28.0001 16.2449 28.0001Z", fill: "#34A853" }),
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.39332 18.2801C9.14842 17.5601 9.00928 16.791 9.00928 16.0001C9.00928 15.2092 9.14842 14.4401 9.39332 13.7201V10.611H5.30241C4.4731 12.231 4 14.0638 4 16.0001C4 17.9365 4.4731 19.7692 5.30241 21.3892L9.39332 18.2801Z", fill: "#FBBC05" }),
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.2449 8.7727C18.0427 8.7727 19.6568 9.37816 20.9258 10.5673L24.4379 7.12543C22.3173 5.18906 19.5455 3.99997 16.2449 3.99997C11.4583 3.99997 7.31727 6.68906 5.30243 10.6109L9.39334 13.72C10.3562 10.8836 13.0557 8.7727 16.2449 8.7727Z", fill: "#EA4335" }))),
        alt: 'Google sign in',
    };
    return React.createElement(Logo, Object.assign({}, commonProps, { source: source }));
};
export default LogoGoogle;
//# sourceMappingURL=index.js.map